import React from 'react';
import { LegendType } from 'src/shared/types/src';

type LegendPropTypes = {
    data: LegendType[],
    title: string
}

const LegendsELG: React.FC<LegendPropTypes> = ({ data = [], title = '' }) => {

    return (
        <div className='border border-gray-70 rounded-3 pd-12'>
            <p className='fs-12 fw-semibold text-black'>{title}</p>
            <div>
                
                <div className='d-flex align-items-center flex-wrap legend-wrapper mx-n-8'>
                    {data.map((el) => {
                        return (
                            <div className={`mg-t-10 pd-x-8 ${el?.color === 'N/A' || !el?.color ? 'w-100' : ''}`}>
                                <div className={`legend-item position-relative ${el?.color === 'N/A' ? 'pd-l-20' : 'pd-l-15'}`}>
                                    <div className='position-absolute start-0 legend-color-item'>
                                        {el?.color ? (
                                            el.color === 'N/A' ? (
                                                <div className='fs-8 text-gray-300'>N/A</div>
                                            ) : (
                                                <>
                                                <span className="legend-circle rounded report-dot-legend-print" style={{ color: el.color }}>●</span>
                                                <div className='legend-circle rounded print-element-hide' style={{ backgroundColor: el.color }}></div></>
                                            )
                                        ) : (
                                            <div className='legend-circle rounded border border-gray-400'></div>
                                        )}
                                    </div>
                                    <p className='fs-10 text-black mb-0'>{el?.label}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
};

export default LegendsELG